import moment from "moment-timezone";
import "moment/locale/he";

const JERUSALEM = "Asia/Jerusalem";

export function getDateAndTime(data?: Date): string {
  return data
    ? moment(data)
        .tz(JERUSALEM)
        .locale("he")
        .format("HH:mm, D בMMMM YYYY")
    : "";
}

export function getDateWithoutTime(date?: Date): string {
  return date
    ? moment(date).tz(JERUSALEM).locale("he").format("D בMMMM YYYY")
    : "";
}
